module.exports = __webpack_public_path__ + "static/media/filter.56a132d1.svg";